import { useAuth } from "../contexts/AuthContext";
import { AdminData } from "../types";
import { createApiHeadersGetter } from "../utils/api-headers";
import { API_BASE_URL } from '../config/api-config';

const ADMIN_URL = `${API_BASE_URL}/admin`;

interface APIError {
    message: string;
    code?: string;
    details?: any;
}

export const useAdminApi = () => {
    const { getAuthToken } = useAuth();
    const getHeaders = createApiHeadersGetter(getAuthToken);

    const getAdminData = async (): Promise<AdminData> => {
        const headers = await getHeaders();
        const response = await fetch(ADMIN_URL, {
            method: 'GET',
            headers
        });
        if (!response.ok) throw new Error('Failed to fetch admin data');
        return response.json();
    };

    return {
        getAdminData
    };
}